import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '@fontsource-variable/inter';
import '@fontsource-variable/space-grotesk';
import '@fontsource-variable/jetbrains-mono';
import { AppShell } from './AppShell';
import { forceWindowedMode, installDevTgShim } from './lib/tg';
import './index.css';

// Telegram decides fullscreen at launch (via the tgWebAppFullscreen hash param,
// remembered per Main Mini App) before React mounts. Exit it here, synchronously
// before the first render, so the corrective frame lands as early as possible
// instead of after AppShell's post-paint effect — otherwise fullscreen flashes.
const launchWebApp = window.Telegram?.WebApp;
if (launchWebApp) forceWindowedMode(launchWebApp);

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5_000,
      gcTime: 60_000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

const root = document.getElementById('root');
if (!root) throw new Error('Root element #root not found in index.html');

installDevTgShim().finally(() => {
  createRoot(root).render(
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <AppShell />
      </QueryClientProvider>
    </StrictMode>,
  );
});
